import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/b.webp'
import _imports_1 from '@/assets/c.webp'
import _imports_2 from '@/assets/d.webp'


const _hoisted_1 = { class: "bg-portada container-fluid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"#000000a4"},
  class: "col-6"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-4 text-center pt-2" }, "ESPECIALISTAS EN CARGA AEREA, MARITIMA Y TERRESTRE."),
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 text-center pt-2" }, "CONSOLIDAMOS TU CARGA DESDE CUALQUIER PARTE DEL MUNDO.")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bg-quienessomos container-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "rotuloquienessomosmt-5 mb-3" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "Servicios"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Brindamos un servicio integral sustentable, basado en su tranquilidad, seguridad y enfoque de su empresa Logramos que el cliente invierta su tiempo en negocios, no en trámites, potenciando así sus oportunidades comerciales y de inversión con proveedores "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-4 mb-3" }, [
        /*#__PURE__*/_createElementVNode("div", {
          style: {"background":"#fb7626"},
          class: "col p-3 text-white"
        }, " Consolidado de carga de cualquier sitio del mundo hacia Honduras. "),
        /*#__PURE__*/_createElementVNode("div", {
          style: {"background":"rgb(10, 24, 54) none repeat scroll 0% 0%"},
          class: "col p-3 text-white"
        }, " Importamos y Exportamos de cualquier sitio del mundo hacia Honduras. "),
        /*#__PURE__*/_createElementVNode("div", {
          style: {"background":"#fb7626"},
          class: "col p-3 text-white"
        }, " Manejamos carga aerea y maritima desde y hacia cualquier parte del mundo. ")
      ]),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "maritima" }, "CARGA MARITIMA"),
            /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "terrestre" }, "CARGA TERRESTRE"),
            /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "aerea" }, "CARGA AEREA"),
            /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cabecera = _resolveComponent("cabecera")!
  const _component_pie = _resolveComponent("pie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cabecera),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        id: "portada",
        class: _normalizeClass([_ctx.clase, "row"])
      }, _hoisted_3, 2)
    ]),
    _hoisted_4,
    _createVNode(_component_pie)
  ], 64))
}